module.exports = "images/reglage.510d86f4.png";